export const TestAI={
    FILE_SUMMARIZATION:1,
    RESEARCH:2,
    RESEARCH_REFERENCE:3,
    ARTICLE:4,
    TESTING:5,
}